import { ComponentPropsWithoutRef, ElementType } from 'react';
import { Box, styled } from '@material-ui/core';
import { distances } from '../../../styles';

const RoundedContainer = styled(Box)(({ theme }) => ({
  borderRadius: 12,
  backgroundColor: theme.palette.common.white,
  border: '1px solid #EEF0F2',
  padding: `${distances.px.base} ${distances.px.medium}`
}));

type RoundedContainerProps<C extends ElementType> = {
  component?: C;
} & ComponentPropsWithoutRef<C>;

export const SRoundedContainer = <C extends ElementType = typeof Box>({
  component,
  children,
  ...props
}: RoundedContainerProps<C>) => {
  const Component = component || Box;
  return (
    <RoundedContainer component={Component} {...props}>
      {children}
    </RoundedContainer>
  );
};
